import request from '@/request'

const part_url = '/recruit/sign/';

function getUserSignInfo(data) {
  let url = part_url + "getUserSignInfo";
  return request.get(url, data)
}

function getUserSignInfoRecent(data) {
  let url = part_url + "getUserSignInfoRecent";
  return request.get(url, data)
}

function getUserSignInfoRecentTwo(data) {
  let url = part_url + "getUserSignInfoRecentTwo";
  return request.get(url, data)
}

function getById(data) {
  let url = part_url + "getById";
  return request.get(url, data)
}

function addSignInfo(data) {
  let url = part_url + "addSignInfo";
  return request.post(url, {}, data)
}

function updateSignInfo(data) {
  let url = part_url + "updateSignInfo";
  return request.post(url, {}, data)
}

/**
 * 检查是否同一单位只能报一个岗位
 */
function checkIsSign(data) {
  let url = part_url + "checkIsSign";
  return request.post(url, {}, data)
}

function cancelSignInfo(data) {
  let url = part_url + "cancelSignInfo";
  return request.get(url, data)
}

function getSignList(data) {
  let url = part_url + "getSignList";
  return request.get(url, data)
}

function getSignListPost(data) {
  let url = part_url + "getSignListPost";
  return request.post(url, data)
}

function signPay(data) {
  let url = part_url + "signPay";
  return request.post(url, {}, data)
}

function endPay(data) {
  let url = part_url + "checkEndPay";
  return request.get(url, data)
}

function joinExam(data) {
  let url = part_url + "joinExam";
  return request.get(url, data)
}

function getSysAreaList() {
  let url = part_url + "treeChinaArea";
  return request.get(url);
}

function getSelectNationList() {
  let url = part_url + "getSelectNationList";
  return request.get(url);
}

function getSchoolFeatureList() {
  let url = part_url + "getSchoolFeatureList";
  return request.get(url);
}


export default {
  getUserSignInfo,
  getUserSignInfoRecent,
  getUserSignInfoRecentTwo,
  getById,
  addSignInfo,
  cancelSignInfo,
  updateSignInfo,
  getSignList,
  getSignListPost,
  checkIsSign,
  signPay,
  endPay,
  joinExam,
  getSysAreaList,
  getSelectNationList,
  getSchoolFeatureList,
};



// WEBPACK FOOTER //
// ./src/api/sign.js